import React from 'react';

const Home = () => {
  return (
  
      
      <h1><br /><br /><br />This is the Home Page Content</h1>
 
  );
};

export default Home;